import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Wrapper = styled.nav`
  border-top: ${({ theme }) => theme.palette.grey[3]} solid 1px;
  background-color: ${({ theme }) => theme.palette.colors.white};
  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    display: flex;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: none;
  }
`;

const MenuItem = styled.li`
  flex-grow: 1;
  flex-basis: 0;
  border-bottom: ${({ active, theme }) => (active ? theme.palette.primary.main : 'transparent')} solid 2px;
  > a {
    color: ${({ active, theme }) => (theme.palette.navbar.color[active ? 'active' : 'default'])};
    font-weight: 600;
    text-decoration: none;
    > div {
      display: block;
      width: 100%;
      height: 44px;
      line-height: 44px;
      text-align: center;
    }
  }
`;

const renderMenuItemContent = (linkWrapper, label) => {
  const { elementType: ElementType, elementProps } = linkWrapper;
  return (
    <ElementType {...elementProps}>
      <div>
        {label}
      </div>
    </ElementType>
  );
};

const NavBar = ({ className, items }) => (
  <Wrapper className={className}>
    <ul>
      {items.map((item) => (
        <MenuItem key={item.linkWrapper.elementProps.to} active={item.active}>
          {renderMenuItemContent(item.linkWrapper, item.label)}
        </MenuItem>
      ))}
    </ul>
  </Wrapper>
);

NavBar.displayName = 'NavBar';

NavBar.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    active: PropTypes.bool,
    linkWrapper: PropTypes.shape({
      elementType: PropTypes.elementType.isRequired,
      elementProps: PropTypes.shape({}).isRequired,
    }).isRequired,
  })).isRequired,
};

export default NavBar;
